/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { UpdateFeeConfigOptions, UpdateFeeConfigResponses } from '../types/UpdateFeeConfig'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. The new rate applies to every period that has not been billed yet, so it is best changed right after a successful daily settlement run.
 * @summary Update the trading fee configuration of a tenant for a tier.
 * {@link /v1/fees/config/:tenant_id/:tier}
 */
export function updateFeeConfig<ThrowOnError extends boolean = true>(
  options: Options<UpdateFeeConfigOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateFeeConfigResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/fees/config/{tenant_id}/{tier}',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateFeeConfigResponses, ThrowOnError>>,
  )
}
